import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { publicSend } from "@/lib/derivPublic";

/* 🔥 Best pairs right now — ranks a shortlist of Pro Trade markets by recent
   tick momentum (last 50 ticks). Entry-quality context from a recent sample
   only — it never predicts the next move. Click a chip to load that chart. */
const WATCH = [
  ["frxEURUSD", "EUR/USD"], ["frxGBPUSD", "GBP/USD"], ["frxUSDJPY", "USD/JPY"],
  ["frxAUDUSD", "AUD/USD"], ["frxXAUUSD", "Gold"], ["frxXAGUSD", "Silver"],
  ["R_75", "Vol 75"], ["R_100", "Vol 100"], ["1HZ75V", "Vol 75 (1s)"], ["1HZ100V", "Vol 100 (1s)"],
];

export const BestPairsStrip = ({ current, onPick }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let stop = false;
    const scan = async () => {
      const out = await Promise.all(WATCH.map(async ([sym, label]) => {
        try {
          const h = await publicSend({ ticks_history: sym, count: 50, end: "latest", style: "ticks" });
          const prices = (h?.history?.prices || []).map(Number);
          if (prices.length < 20) return null;
          const ups = prices.slice(1).filter((p, i) => p > prices[i]).length;
          const upPct = Math.round((ups / (prices.length - 1)) * 100);
          return { sym, label, upPct, heat: Math.abs(upPct - 50) };
        } catch { return null; }
      }));
      if (stop) return;
      const ok = out.filter(Boolean).sort((a, b) => b.heat - a.heat);
      if (ok.length) setRows(ok);
      else setTimeout(() => { if (!stop) scan(); }, 5000); // socket warm-up retry
    };
    scan();
    const t = setInterval(scan, 30000);
    return () => { stop = true; clearInterval(t); };
  }, []);

  if (!rows.length) return null;
  const top = rows.slice(0, 3);
  return (
    <div data-testid="pro-best-pairs" className="flex items-center gap-2 px-2 sm:px-3 py-1.5 border-b border-white/10 bg-[#0D1322] overflow-x-auto">
      <span className="flex items-center gap-1 text-[9px] font-mono font-black uppercase tracking-[0.18em] text-[#F7B731] shrink-0">
        <Flame className="h-3 w-3" /> Moving now
      </span>
      {top.map((r) => (
        <button key={r.sym} data-testid={`pro-best-pair-${r.sym}`} onClick={() => onPick?.(r.sym)}
          className={`shrink-0 px-2.5 py-1 rounded-md border text-[10px] font-mono font-bold transition ${current === r.sym
            ? "border-vts-blue bg-vts-blue/20 text-white"
            : "border-white/10 bg-[#131722] text-white/70 hover:border-vts-blue/60 hover:text-white"}`}>
          {r.label} {r.upPct >= 50 ? "↑" : "↓"} {r.upPct >= 50 ? r.upPct : 100 - r.upPct}% {r.upPct >= 50 ? "upticks" : "downticks"}
        </button>
      ))}
      <span className="shrink-0 text-[8px] font-mono text-white/35">last 50 ticks · recent sample, not a prediction</span>
    </div>
  );
};

export default BestPairsStrip;
